import React from "react"
import "./App.css"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Particles from "./components/Particles"

const Home = () => (
  <div
    style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <div style={{ color: "white" }}>
      <h1>
        <span
          style={{ backgroundColor: "black", padding: 3, fontSize: "1.5em" }}
        >
          M
        </span>
        ETAGORA
      </h1>
    </div>
  </div>
)

function App() {
  return (
    <Router>
      <Particles />
      <Switch>
        <Route path="/" exact component={Home} />
      </Switch>
    </Router>
  )
}

export default App
